{
  "save": "Enregistrer",
  "cancel": "Annuler",
  "submit": "Envoyer",
  "loading": "Chargement...",
  "ok": "OK",
  "add": "+",
  "continue": "Continuer",
  "select": "Choisir...",
  "selectedCount": "{{count}} sélectionné(s)",
  "notAvailable": "S/O",
  "close": "Fermer",
  "compressingImage": "Compression de l'image...",
  "hide": "Masquer",
  "show": "Afficher",
  "applying": "Application...",
  "back": "Retour",
  "delete": "Supprimer",
  "duplicate": "Dupliquer",
  "lock": "Verrouiller",
  "mixed": "Mixte",
  "multipleValues": "Valeurs multiples",
  "next": "Suivant",
  "or": "ou",
  "remove": "Retirer",
  "unlock": "Déverrouiller",
  "units": {
    "meters": "Mètres",
    "feet": "Pieds"
  },
  "sandbox": {
    "title": "Bac à sable de {{name}}",
    "badge": "Bac à sable",
    "section": "Votre bac à sable",
    "description": "Un espace privé pour apprendre et expérimenter"
  }
}
